/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Task,
    TaskFromJSON,
    TaskFromJSONTyped,
    TaskToJSON,
} from './';

/**
 * 
 * @export
 * @interface TaskDataFrame
 */
export interface TaskDataFrame {
    /**
     * 
     * @type {number}
     * @memberof TaskDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof TaskDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof TaskDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Task>}
     * @memberof TaskDataFrame
     */
    data: Array<Task>;
}

export function TaskDataFrameFromJSON(json: any): TaskDataFrame {
    return TaskDataFrameFromJSONTyped(json, false);
}

export function TaskDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(TaskFromJSON)),
    };
}

export function TaskDataFrameToJSON(value?: TaskDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(TaskToJSON)),
    };
}


